// libraries
import React from 'react'

// components

import Section from '/react4xp/components/Section'
import Button from '/react4xp/components/Button'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils'

// props
interface Props {
    logo?: string
    companyName?: string
    htmlArea?: string
    menu?: {
		button?: {
			label: string
			href: string
			target?: '_self' | '_blank'
		}
		items: {
			label: string
			href: string
			target?: '_self' | '_blank'
		}[]
    }
	/** Plain text link (e.g. partner site) shown in footer without a logo */
	footerPartnerLink?: {
		label: string
		href: string
		target?: '_self' | '_blank'
	}
    social?: {
        src: string
        label: string
        href: string
    }[]
}

export default function Footer({
    logo = '/images/svg/logo/logo.svg',
    companyName = 'Nei til EU',
    htmlArea = '<p>Grønlandsleiret 31<br/>0190 Oslo<br/><br/><a href="mailto:neitileu@neitileu.no"><b>neitileu@neitileu.no</b></a><br/><br/>Telefon: <a href="tel:22179020">22 17 90 20</a></p>',
    menu = {
        button: {
            label: 'Bli medlem',
            href: '#',
            target: '_self'
        },
        items: [
            {
                label: 'Om oss',
                href: '#',
                target: '_self'
            },
            {
                label: 'Politikk',
                href: '#',
                target: '_self'
            },
            {
                label: 'Tillitsvalgt',
                href: '#',
                target: '_self'
            },
            {
                label: 'Kalender',
                href: '#',
                target: '_self'
            },
            {
                label: 'Gi en gave',
                href: '#',
                target: '_self'
            }
        ]
    },
    social = [
        {
            src: '/images/svg/social/facebook.svg',
            label: 'Facebook',
            href: 'https://www.facebook.com/NeitilEU'
        },
        {
            src: '/images/svg/social/instagram.svg',
            label: 'Instagram',
            href: 'https://www.instagram.com/neitileu/'
        },
        {
            src: '/images/svg/social/twitter.svg',
            label: 'Twitter',
            href: 'https://twitter.com/neitileu'
        }
    ],
    footerPartnerLink,
}: Props) {
    return (
        <>
        
            <Section
                id='footer'
                bgColor='white'
                paddingTop='medium'
            >
                <div className='container'>
                    <div className='flex'>
                    
                        <div className='left'>

                            <a
                                href='/'
                                className='logo'
                            >
                                <img
                                    src={logo}
                                    alt='Nei til EU'
                                    width={110}
                                    height={110}
                                />
                            </a>

                            <div className='infos'>

                                {isNonWhitespaceString(companyName) && (
                                    <h2 className='h3 company-name'>
                                        {companyName}
                                    </h2>
                                )}

                                {isNonWhitespaceString(htmlArea) && (
                                    <div
                                        dangerouslySetInnerHTML={{ __html: htmlArea }}
                                        suppressHydrationWarning
                                        className='p1 htmlArea'
                                    />
                                )}

                            </div>

                        </div>

                        <div className='right'>

                            <div className='footer-menu'>

                                {menu.button && (
                                    <Button
                                        href={menu.button.href}
                                        target={menu.button.target}
                                        style='solid'
                                        color='primary'
                                        small
                                    >
                                        {menu.button.label}
                                    </Button>
                                )}

                                {menu.items.length > 0 && (
                                    <ul className='items'>
                                        {menu.items.map((item, i) => (
                                            <li key={i}>
                                                <a
                                                    href={item.href}
                                                    target={item.target === '_blank' ? '_blank' : undefined}
                                                    rel={item.target === '_blank' ? 'noopener noreferrer' : undefined}
                                                    className='p1 hover-underline'
                                                >
                                                    {item.label}
                                                </a>
                                            </li>))}
                                    </ul>
                                )}

                                {footerPartnerLink &&
                                    isNonWhitespaceString(footerPartnerLink.href) &&
                                    isNonWhitespaceString(footerPartnerLink.label) && (
                                        <p className='p1 footer-partner-link'>
                                            <a
                                                href={footerPartnerLink.href.trim()}
                                                target={
                                                    footerPartnerLink.target === '_blank'
                                                        ? '_blank'
                                                        : undefined
                                                }
                                                rel={
                                                    footerPartnerLink.target === '_blank'
                                                        ? 'noopener noreferrer'
                                                        : undefined
                                                }
                                                className='hover-underline'
                                            >
                                                {footerPartnerLink.label.trim()}
                                            </a>
                                        </p>
                                    )}

                            </div>

                            {social.length > 0 && (
                                <ul className='social'>
                                    {social.map((item, i) => (
                                        <li key={i}>
                                            <a
                                                href={item.href}
                                                target='_blank'
                                                rel='noopener noreferrer'
                                            >
                                                <img
                                                    src={item.src}
                                                    alt={item.label}
                                                    width={24}
                                                    height={24}
                                                />
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            )}

                        </div>

                    </div>
                </div>
            </Section>

        </>
    )
}